<template>
  <div>
    <van-cell-group>
      <van-cell
        is-link
        :to="'/address?id='+addressId"
        :title="addressId>0?addressTitle:$t('shoppingcart.noAddressTip')"
        :value="$t('common.select')" />
        <div class="address-part" @click="goAddressList">{{ addressDetail }}</div>
    </van-cell-group>
    <div v-for="c in cartContent" :key="c.supplierId" style="margin-top:10px;">
      <van-swipe-cell v-for="p in c.products" :key="p.id" style="margin-bottom:10px;">
        <van-card
          :num="p.buyCount"
          :price="parseFloat(p.unitPrice).toFixed(2)"
          currency="S/."
          :desc="p.specName+'('+(p.stockUnit)+')'"
          :title="p.name"
          class="goods-card"
          :thumb="p.pic">
          <template #tags>
            <van-icon v-if="!p.checked" name="close" color="#EE0A24" />
          </template>
        </van-card>
        <template #right>
          <van-button square type="danger" text="删除" class="op-button" @click="deleteProduct(p.id)" />
        </template>
      </van-swipe-cell>
    </div>
    <div class="price-part">
      <van-row v-if="cartContent.length>0&&canTransport">
        <van-col span="1"></van-col>
        <van-col span="23">
          <van-checkbox v-model="cartContent[0].needTransport" shape="square" @change="checked=>checkNeedTransport(checked,cartContent[0])">{{ $t('shoppingcart.needTransport') }}{{ cartContent[0].agentDeliverFee }}SOL({{ $t('shoppingcart.orderPrice4transportFree').replace('{0}',cartContent[0].orderAmount4agentDeliverFree) }})</van-checkbox>
        </van-col>
      </van-row>
      <van-row>
        <van-col span="1"></van-col>
        <van-col span="7">{{ $t('shoppingcart.productOriginalPrice') }}: {{ priceInfo.originalPrice }}</van-col>
        <van-col span="1"></van-col>
        <van-col span="7">{{ $t('shoppingcart.deposit') }}: {{ priceInfo.totalDeposit }}</van-col>
        <van-col span="1"></van-col>
        <van-col span="7">{{ $t('shoppingcart.agentFreight') }}: {{ priceInfo.freight }}</van-col>
      </van-row>
      <van-row>
        <van-col span="1"></van-col>
        <van-col span="23">{{ $t('shoppingcart.payPrice') }}: {{ priceInfo.needPay }}</van-col>
      </van-row>
      <van-row>
        <van-col span="1"></van-col>
        <van-col span="23">{{ $t('shoppingcart.accountBalance') }}: {{ priceInfo.accountBalance }}</van-col>
      </van-row>
    </div>
    <div class="operation-part">
      <van-cell-group>
        <van-field
          v-model="buyRemark"
          rows="1"
          autosize
          :label="$t('common.remark')"
          type="textarea"
          :placeholder="$t('common.fillTip')"
        />
        <div class="terms-div">
          <van-checkbox v-model="agreeTerms" shape="square" label-disabled>
            <span class="common-text">{{ $t('common.agree') }}</span>
            <span class="link-type" @click="showTerms"> {{ $t('shoppingcart.termsOfPurchase') }}</span>
          </van-checkbox>
        </div>
      </van-cell-group>
      <van-button
        v-if="!hasProducts2Buy"
        type="danger"
        block
        >
        {{ $t('shoppingcart.noProduct2Buy') }}
      </van-button>
      <van-button
        v-else-if="priceInfo.accountBalance<priceInfo.needPay"
        type="danger"
        block
        >
        {{ $t('shoppingcart.notEnoughMoney') }}
      </van-button>
      <van-button
        v-else
        type="info"
        block
        :loading="ordering"
        :loading-text="$t('shoppingcart.ordering')"
        @click="payAndOrder"
        >
        {{ $t('shoppingcart.payAndOrderButton') }}
      </van-button>
    </div>
    <div style="height:60px"></div>

    <van-popup v-model="termsShow" :style="{ height: '80%', width: '90%' }">
      <terms />
    </van-popup>
  </div>
</template>

<script>
import { getAllAddressDetail } from '@/api/address'
import { getCartContent, deleteProduct, checkNeedTransport } from '@/api/shoppingcart'
import { generateOrder, batchPayOrder } from '@/api/order'
import i18n from '@/i18n'
import { Toast } from 'vant'
import terms from '@/components/terms'

export default {
  components: {
    terms
  },
  data() {
    return {
      addressId: 0,
      addressTitle: '',
      addressDetail: '',
      cartContent: [],
      hasProducts2Buy: true,
      priceInfo: {},
      buyRemark: '',
      agreeTerms: false,
      termsShow: false,
      ordering: false,
      canTransport: window.location.hostname != 'k.starpay.pe'
    }
  },
  created() {
    this.fetchAddress()
    this.fetchContent()
  },
  methods: {
    fetchAddress() {
      getAllAddressDetail().then(rep => {
        if (rep.data.length > 0) {
          if (this.$route.query.addressId) {
            rep.data.forEach(a => {
              if (this.$route.query.addressId == a.id) {
                this.addressId = a.id
                this.addressTitle = '[' + a.tag + '] ' + a.contact + '/' + a.contactNumber
                this.addressDetail = a.address
              }
            })
          } else {
            rep.data.forEach(a => {
              if (a.isDefault) {
                this.addressId = a.id
                this.addressTitle = '[' + a.tag + '] ' + a.contact + '/' + a.contactNumber
                this.addressDetail = a.address
              }
            })
          }
        }
      })
    },
    fetchContent() {
      getCartContent().then(rep => {
        this.hasProducts2Buy = false
        this.cartContent = rep.data.content || []
        this.cartContent.forEach(c => {
          c.products.forEach(p => {
            if (p.checked && !p.deletedOrOffSell) {
              this.hasProducts2Buy = true
            }
          })
        })
        this.priceInfo = rep.data.priceInfo || {}
      })
    },
    checkNeedTransport(checked, content) {
      checkNeedTransport({ supplierId: content.supplierId, checked: checked }).then(rep => {
        this.fetchContent()
      })
    },
    deleteProduct(cartItemId) {
      deleteProduct({ id: cartItemId }).then(rep => {
        this.fetchContent()
        this.$parent.fetchCartProductCount()
      })
    },
    payAndOrder() {
      if (this.addressId > 0 && this.agreeTerms) {
        this.ordering = true
        generateOrder({ addressId: this.addressId, buyRemark: this.buyRemark }).then(rep => {
          if (!rep.data.error) {
            let orderNumbers = rep.data
            batchPayOrder({ orderNumbers: orderNumbers }).then(payRep => {
              if (payRep.code == 1000) {
                Toast.success(i18n.t('shoppingcart.buyedTip'))
                this.$parent.fetchCartProductCount()
              }
              this.ordering = false
            })
          } else {
            this.ordering = false
          }
        })
      } else if (!this.agreeTerms) {
        Toast.fail(i18n.t('shoppingcart.termsTip'))
      } else {
        Toast.fail(i18n.t('shoppingcart.selectAddressTip'))
      }
    },
    goAddressList() {
      this.$router.push('/address?id=' + this.addressId)
    },
    showTerms() {
      this.termsShow = true
    }
  }
}
</script>

<style scoped>
.op-button {
  height: 100%;
}
.price-part {
  font-size: 14px;
}
.price-part .van-row {
  margin-top: 10px;
  margin-bottom: 10px;
}
.address-part {
  padding-left:16px;
  padding-right: 16px;
  padding-bottom: 10px;
  color: #969799;
  font-size: 12px;
}
.van-cell::after {
  padding-bottom: 0px;
  border-bottom: 0;
}
.terms-div {
  padding: 10px 16px;
}
</style>